<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12 col-lg-6">
                <FormInput label="Dirección" type="text" name="direccion" id="direccion" rules="required" v-model="direccionFiscal.direccion" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Nif" type="text" name="nif" id="nif" rules="required" v-model="direccionFiscal.nif" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Número de cuenta" type="text" name="número de cuenta" id="n_cuenta" rules="required" v-model="direccionFiscal.n_cuenta" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="direccionFiscal.nombre" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Código postal" type="text" name="código postal" id="cp" rules="required" v-model="direccionFiscal.cp" />
            </div>
            <div class="col-12 col-lg-6">
                <FormInput label="Ciudad" type="text" name="ciudad" id="ciudad" rules="required" v-model="direccionFiscal.ciudad" />
            </div>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['direccionFiscal'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado');
                }
            }
        }
    }
</script>